import React, {Component} from 'react';
import { Button } from '../../components/FormUI';
import FollowUpService from '../../api/services/FollowUpService';
import moment from 'moment';
import {saveAs} from "file-saver";

export default class DocumentsSection extends Component{
    state = {isLoading:{}};
    handleDownload = (docType)=>{
        if(this.state.isLoading[docType])return;
        let followup = this.props.followup;
        let tpdoc = {
            "AssesmentId" : followup.assessmentId,
            "DocumentCategory" :docType
        };

        let isl = this.state.isLoading;
        isl[docType] = true;
        this.setState({isLoading:isl});

        FollowUpService.GetDocument(tpdoc).then((doc)=>{
            console.log('Doc:', doc)
            let filename = followup.followupType + '-' + moment().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS) + '.doc';
            saveAs(doc, filename);
            let isl = this.state.isLoading;
            isl[docType] = false;
            this.setState({isLoading:isl});            
        })
    }
    render(){
        
        return(
            <div className="docs-section">
                <h1>Documents</h1>
                <Button className='white' caption='Treatment Plan' onClick={()=>this.handleDownload('TreatmentPlan')} isBusy={this.state.isLoading['TreatmentPlan']}  />
                {/*<Button className='white' caption='Diabetes Plan' onClick={()=>this.handleDownload('Diabetes')} isBusy={this.state.isLoading['Diabetes']} /> */}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/followup/DocumentsSection.js